import { gql } from 'graphql-request'

export const APPROVE_CAMPAIGN = gql`
  mutation ApproveCampaign($id: Int!) {
    approveCampaign(id: $id) {
      message
    }
  }
`
